// extracted by mini-css-extract-plugin
export var equalColumn = "_g9-0";